import { render } from "./RequirementCardDescriptionField.vue?vue&type=template&id=6d29e8c0"
import script from "./RequirementCardDescriptionField.vue?vue&type=script&lang=js"
export * from "./RequirementCardDescriptionField.vue?vue&type=script&lang=js"

import "./RequirementCardDescriptionField.vue?vue&type=style&index=0&id=6d29e8c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__